import React, {useEffect, useState} from "react";
import {Grid, Header, Image, Segment, Table} from 'semantic-ui-react'
import LoggingRow from "./LoggingRow";
import {useNavigate} from "react-router";

export default function Home(props) {
    const [data, setData] = useState({loggings: [], loading: true});

    const navigate = useNavigate()

    useEffect(() => {
        document.title = 'Home'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) {
            navigate("/login")
        }
        fetchData()
    }, [])

    const fetchData = async () => {
        try {
            var url = API_URL + '/api/private/tanker/v1/loggings'

            const token = sessionStorage.token
            if (!(token && token.length > 0)) navigate('/login')

            fetch(url, {headers: new Headers({'Authorization': `Bearer ${token}`})})
                .then(function (response) {
                    if (response.status >= 400) {
                        throw new Error("Bad response from server");
                    }
                    return response.json();
                })
                .then(function (data) {
                    setData({loggings: data, loading: false});
                });
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <Grid columns={2} style={{marginTop: '7em'}} stackable>
            <Grid.Row>
                <Grid.Column>
                    <h1>POJEX</h1>
                    <h2>Business Controlling Solution for the City of Code</h2>
                </Grid.Column>
                <Grid.Column>
                    <Header>Loggings</Header>
                    <Table>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Date</Table.HeaderCell>
                                <Table.HeaderCell>Name</Table.HeaderCell>
                                <Table.HeaderCell>Message</Table.HeaderCell>
                                <Table.HeaderCell>Duration</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {data.loggings && data.loggings.map((logging) => <LoggingRow key={logging.id}
                                                                                         logging={logging}/>)
                            }
                        </Table.Body>
                    </Table>

                </Grid.Column>
            </Grid.Row>
        </Grid>
    )
}
